import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

function DesktopNav({ isHomePage }) {

    const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
      const handleScroll = () => {
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        
        let ratio = scrollY / windowHeight;
        if (ratio > 1) ratio = 1;
        
        setIsScrolled(scrollY > 50);
      };
  
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);

  return (
    <ul className="hidden md:flex space-x-8 text-lg">
      <li className="relative">
        <NavLink
          to="projects"
          className={({ isActive }) => 
            `px-6 py-2 relative group ${isActive ? 'text-gray-900' : ''} ${isHomePage ? 'text-white' : ''} ${isScrolled ? 'text-white' : ''} transition-all duration-1000`
          }
        >
          {({ isActive }) => (
            <>
              Projects
              <span className={`absolute left-1/2 bottom-0 h-px bg-current transform -translate-x-1/2 text-gray-300 transition-all duration-500 ${
                isActive ? 'w-5/12' : 'w-0 group-hover:w-full'
              }`}></span>
            </>
          )}
        </NavLink>
      </li>
      <li className="relative">
      <NavLink
          to="about"
          className={({ isActive }) => 
            `px-6 py-2 relative group ${isActive ? 'text-gray-900' : ''} ${isHomePage ? 'text-white' : ''} ${isScrolled ? 'text-white' : ''} transition-all duration-1000`
          }
        >
          {({ isActive }) => (
            <>
              About
              <span className={`absolute left-1/2 bottom-0 h-px bg-current transform -translate-x-1/2 text-gray-300 transition-all duration-500 ${
                isActive ? 'w-5/12' : 'w-0 group-hover:w-full'
              }`}></span>
            </>
          )}
        </NavLink>
      </li>
      <li className="relative">
      <NavLink
          to="contact"
          className={({ isActive }) => 
            `px-6 py-2 relative group ${isActive ? 'text-gray-900' : ''} ${isHomePage ? 'text-white' : ''} ${isScrolled ? 'text-white' : ''} transition-all duration-1000`
          }
        >
          {({ isActive }) => (
            <>
              Contact
              <span className={`absolute left-1/2 bottom-0 h-px bg-current transform -translate-x-1/2 text-gray-300 transition-all duration-500 ${
                isActive ? 'w-5/12' : 'w-0 group-hover:w-full'
              }`}></span>
            </>
          )}
        </NavLink>
      </li>
    </ul>
  );
}

export default DesktopNav;